export default __webpack_public_path__ + "static/contact-3244818169e6082dc0ae0249c77597b6.png";